import { CoreUiException } from "./core-ui-exception";

/**
 * Occurrs when the http error happens, and the HttpErrorInterceptor
 * cannot create a more specific exception.
 *
 * Either the service should create a more specific exception,
 * or a generic error message will be displayed.
 */
export class HttpClientException extends CoreUiException {

    constructor(message: string, originalError?: any) {

        super("HTTPClientException", message, originalError);

        // Work around for Error Extension
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, HttpClientException.prototype);
    }
}
